import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const FlightPathIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={className}
        data-testid={testId}
        fill='none'
        viewBox='0 0 16 16'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M3 2L13 2C14.5 2 14.5 5 13 5L3 5C1.5 5 1.5 8 3 8L13 8C14.5 8 14.5 11 13 11L3 11C1.5 11 1.5 14 3 14L13 14'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
        />
    </svg>
);

export default FlightPathIcon;
